import { render, staticRenderFns } from "./MarketingArgument.v2.vue?vue&type=template&id=436425d8"
import script from "./MarketingArgument.v2.vue?vue&type=script&lang=js"
export * from "./MarketingArgument.v2.vue?vue&type=script&lang=js"
import style0 from "./MarketingArgument.v2.vue?vue&type=style&index=0&id=436425d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports